import { useContext } from 'react';
import { useRouter } from 'next/router';
import { MicrositeContext } from 'context';
import { PageContainer } from './PageContainer';
import { Header, LumisHeader } from './Header';
import { Footer } from './Footer';
import { InnerFooter } from './InnerFooter';
import { PageContent } from './PageContent';
import { useTheme } from '@emotion/react';
import { useStore } from 'hooks/useStore';
import { PageRoutes } from 'constants/pageRoutes';

export const isLumisRoute = (pathname: string) =>
  pathname.startsWith(PageRoutes.offerWizard);

export function Layout({ children }) {
  const micrositeConfig = useContext(MicrositeContext);
  const theme = useTheme();
  const hideChrome = useStore((state) => state.hideChrome);
  const hideInnerFooterFlag = useStore((state) => state.hideInnerFooter);
  const hideHeaderAndFooter =
    hideChrome ||
    (micrositeConfig && micrositeConfig.iFrameConfig?.hideHeaderAndFooter);
  // `hideInnerFooter` (LUM-380) is a narrower opt-out: suppress only the
  // <InnerFooter /> (the SECURE CONNECTION + UUID/s12y/TID block whose long
  // unbreakable strings overflow on narrow viewports) while keeping the
  // dark <Footer /> bar visible. The dark Footer anchors PageContainer's
  // bottom edge to the viewport — without it the page bg clips short of
  // the viewport bottom and the body's white bg shows through.
  const hideInnerFooter = hideHeaderAndFooter || hideInnerFooterFlag;

  const { pathname } = useRouter();
  const showLumisHeader = isLumisRoute(pathname);

  return (
    <PageContainer>
      {!hideHeaderAndFooter ? (
        showLumisHeader ? (
          <LumisHeader />
        ) : (
          <Header />
        )
      ) : null}
      <PageContent data-cy={`theme-${theme.customTheme?.name}`}>
        {children}
      </PageContent>
      {!hideInnerFooter ? <InnerFooter /> : null}
      {!hideHeaderAndFooter ? <Footer /> : null}
    </PageContainer>
  );
}
